import { ChangeEvent, Fragment, useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DiagnosisContext } from ".";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import AddDiagnosis from "./AddDiagnosis";
import { useMutation } from "react-query";
import {
  DeleteDiagnosis,
  getDiagnosisList,
  saveOrUpdateDignosis,
} from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
// import LogComonent from "../layouts/LogComonent";
import { TableDataLoading } from "../../../utilis/component/SkeletonLoading/PageLoadSkeleton";
import { DiagnosisListType, IcdCodeTypes, preparePayload } from "./types";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import EmptyListAlert from "../layouts/EmptyListAlert";
import HistoryComponent from "../layouts/HistoryComponent";

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 6,
  width: 66,
  height: 34,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    backgroundColor: theme.palette.grey[400],
    position: "relative",
    width: "100%", // Match width of the container
    height: "100%", // Match height of the container
    display: "flex",
    alignItems: "center",
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 40,
    height: 20,
    margin: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "8px",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[500],
    borderRadius: 10,
    "&::before": {
      content: '"Inactive"',
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    top: "50%",
    transform: "translateY(-50%)",
    "&.Mui-checked": {
      transform: "translateX(16px) translateY(-50%)",
      "& .MuiSwitch-thumb": {
        backgroundColor: theme.palette.primary.main,
        "&::before": {
          content: '"Active"',
        },
      },
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.grey[500],
      },
    },
  },
}));

function DiagnosisList() {
  const { showSnackbar } = usePopup();
  const { setTrigger } = useContext(HL7ContexTriggerContex);
  const { encounterId } = useParams();
  const { list, setEdit, setList, edit } = useContext(DiagnosisContext);
  const [open, setOpen] = useState(false);
  const [selected,setSelected] = useState(-1)
  const handleClose = () => {
    setOpen(false);
    setEdit(null);
  };

  const { mutate: fetchDiagnosis, isLoading: diagnosisLoading } = useMutation(
    getDiagnosisList,
    {
      onSuccess: (result) => {
        if (result.statusCode == "200") {
          setList(result.response);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
          });
        }
      },
    }
  );

  const { mutate: updateDiagnosis, isLoading: updateLoading } = useMutation(
    saveOrUpdateDignosis,
    {
      onSuccess: (result) => {
        setEdit(null);
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
          });
          fetchDiagnosis(encounterId as string);
          setTrigger({
            encounterId:encounterId as string,
            tab:"diagnosis"
          })
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "error",
          });
        }
      },
    }
  );

  const { mutate: deleteDiagnosis,isLoading:deleteLoading} = useMutation(DeleteDiagnosis, {
    onSuccess: (result) => {
     if(result.responseIndicator == "success") {
      fetchDiagnosis(encounterId as string)
      showSnackbar({
        message:result.responseMessage,
        variant:"success",
        open:true,
        duration:2000
      })
      setTrigger({
        encounterId:encounterId as string,
        tab:"diagnosis"
      })
    }else{
      showSnackbar({
        message:result.responseMessage,
        variant:"warning",
        open:true,
        duration:2000
      })
    }
    },
  });
  const handleDelete = (diagnosisId: number,index:number) => {
    deleteDiagnosis({ id: encounterId as string, diagnosisId: diagnosisId });
    setSelected(index)
  };

  const handleStatusChange = (
    e: ChangeEvent<HTMLInputElement>,
    data: DiagnosisListType,
    index:number
  ) => {
    const isActive = e.target.checked;
    const params = preparePayload({
      ...data,
      isActive,
      encounterId: parseInt(encounterId as string),
    });
    updateDiagnosis(params);
    setSelected(index)
  };

  useEffect(() => {
    fetchDiagnosis(encounterId as string);
  }, []);

  return (
    <TableContainer component={Paper}>
      <div className="flex justify-end items-center">
     
      </div>
      {!diagnosisLoading && (
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            <TableRow>
              {headings.map((heading: string, index: number) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  key={`tableHeading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={headings.length}>
                 <EmptyListAlert alert="No diagnosis" isData={Boolean((list.length || open))}>
                 <div className="flex items-center justify-end p-4 gap-2">
                  {!open && (
                    <Button
                      onClick={() => {
                        setOpen(true);
                      }}
                      color="success"
                      endIcon={<AddCircleIcon />}
                    >
                      add
                    </Button>
                  )}
                  <div>
                       {/* <LogComonent  /> */}
                       <HistoryComponent logProps={{title:"Diagnosis", field:"diagnosis"}} title="Diagnosis" tableprops={tableProps} />
                  </div>
                </div>
                 </EmptyListAlert>
                <Collapse in={open} className="relative">
                  <AddDiagnosis close={handleClose} />
                </Collapse>
              </TableCell>
            </TableRow>
            {list?.map((row, index) => (
              <Fragment key={`diagnosisListId${index}`}>
                <TableRow
                  key={row.diagOrder}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.diagOrder}</TableCell>
                  <TableCell>{(row.icdCode as IcdCodeTypes).icdCode}</TableCell>
                  <TableCell>{row.diagnosisType}</TableCell>
                  <TableCell>
                    {row.diagnosisType == "Principal" ? (
                      "Active"
                    ) : (updateLoading && selected == index) ? (
                      <CircularProgress size={18} />
                    ) : (
                      <Android12Switch
                        checked={Boolean(row.isActive)}
                        value={index}
                        onChange={(e) => {
                          handleStatusChange(e, row,index);
                        }}
                      />
                    )}
                  </TableCell>

                  <TableCell>{(row.icdCode as IcdCodeTypes).icdDescription}</TableCell>
                  <TableCell>
                    <span>
                      {(Boolean(edit) && (edit?.diagnosisId == row.diagnosisId)) ? (
                        <IconButton
                          color="error"
                          onClick={() => {
                            setEdit(null);
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            setEdit(row);
                            setOpen(false);
                          }}
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                      {( deleteLoading && selected == index) ? <CircularProgress size={18} color="error" /> : <IconButton
                        disabled={row.diagnosisType == "Principal"}
                        color="error"
                        onClick={() => {
                          handleDelete(row?.diagnosisId as number,index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={headings.length}>
                    <Collapse
                      in={(Boolean(edit) && (edit?.diagnosisId == row.diagnosisId))}
                    >
                      <AddDiagnosis close={handleClose} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      )}
      {diagnosisLoading && <TableDataLoading cols={headings.length} rows={9} />}
    </TableContainer>
  );
}

export default DiagnosisList;

const headings = [
  "ORDER",
  "ICD CODE",
  "DIAGNOSIS TYPE",
  "STATUS",
  "NARRATION",
  "OPTIONS",
];
const tableProps = [
  { heading: "ORDER", key: "diagOrder" },
  { heading: "ICD CODE", key: "icdCode.icdCode" },
  { heading: "DIAGNOSIS TYPE", key: "diagnosisType" },
  { heading: "NARRATION", key: "icdCode.icdDescription" }
] 
